"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
export default function OptimierungStarten() {
  return <section data-section-id="40476" id="jetzt-kmu-erfolg-starten" className="dark text-white relative w-full py-24 overflow-hidden !bg-[hsl(21,90%,48%)] lg:py-32">
      <div className="absolute inset-0 bg-linear-to-br from-primary to-orange-600 shadow-[inset_0_0_60px_rgba(0,0,0,0.1)] z-0" />
      <div className="absolute inset-0 bg-white/5 z-0 pointer-events-none" />
      <div className="relative z-10 container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white font-sans drop-shadow-md">
            Bereit, online durchzustarten?
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-medium leading-relaxed">
            Erstellen Sie jetzt Ihre professionelle Website – in Minuten statt
            Wochen. Kostenlos starten, jederzeit upgraden.
          </p>
          <div className="pt-4">
            <a href="https://dashboard.pagemaker24.ch/sign-up" className="inline-flex items-center justify-center gap-2 bg-white rounded-lg px-10 py-4 text-lg font-bold shadow-2xl transition-all duration-300 hover:bg-white/95 hover:scale-105" style={{
            color: "hsl(16,88%,54%)"
          }}>
              Kostenlos starten
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}